import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import AccountView from 'src/views/account';
import DashboardView from 'src/views/Dashboard';
import NotFoundView from 'src/views/errors/NotFoundView';
import AssetView from 'src/views/Asset';
import MobileVehiclesView from 'src/views/Vehicle';
import Alerts from './views/Alert';
// import Organisation from './views/Organisation';
import GeofenceView from './views/Geofence';
import Groups from './views/Groups';
import Reports from './views/Reports';
import Users from './views/Users';
// import Trips from './views/Trips';

const routes = [
	{
		path: 'app',
		element: <DashboardLayout />,
		children: [
			{ path: '/', element: <Navigate to="/app/dashboard" /> },
			{ path: 'account', element: <AccountView /> },
			{ path: 'dashboard', element: <DashboardView /> },
			{ path: 'assets', element: <AssetView /> },
			{ path: 'vehicles', element: <MobileVehiclesView /> },
			{ path: 'geofence', element: <GeofenceView /> },
			// { path: 'organisation', element: <Organisation /> },
			{ path: 'users', element: <Users /> },
			{ path: 'reports', element: <Reports /> },
			{ path: 'groups', element: <Groups /> },
			{ path: 'alerts', element: <Alerts /> },
			// { path: 'trips', element: <Trips /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
	},
	{
		path: '/',
		element: <MainLayout />,
		children: [
			{ path: '404', element: <NotFoundView /> },
			{ path: '/', element: <Navigate to="/app/dashboard" /> },
			{ path: '*', element: <Navigate to="/404" /> }
		]
	}
];

export default routes;
